/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/** @jsx jsx */

import { jsx, css } from '@emotion/react'
import { useIntl } from 'react-intl'
import { type FunctionComponent } from 'react'

import { EuiFormRow, EuiSwitch } from '@elastic/eui'

interface Props {
  onChange: ({ cumulativeView }: { cumulativeView: boolean }) => void
  isLoading?: boolean
  value: boolean
}

const CumulativeViewSwitch: FunctionComponent<Props> = ({ onChange, isLoading, value }) => {
  const { formatMessage } = useIntl()

  return (
    <EuiFormRow fullWidth={true} display='row' hasEmptyLabelSpace={true}>
      <EuiSwitch
        label={formatMessage({
          defaultMessage: 'Cumulative view',
          id: 'billing-usage.filters.cumulativeView',
        })}
        checked={value}
        onChange={(e) => onChange({ cumulativeView: e.target.checked })}
        disabled={isLoading}
        css={css({ alignItems: 'center' })}
      />
    </EuiFormRow>
  )
}

export default CumulativeViewSwitch
